"use strict";
exports.__esModule = true;
exports.calculateDimensionsWithConstraints = void 0;
function calculateDimensionsWithConstraints(_a) {
    var nativeHeight = _a.nativeHeight, nativeWidth = _a.nativeWidth, maxHeight = _a.maxHeight, maxWidth = _a.maxWidth;
    // Calculate the ratios for width and height
    var widthRatio = maxWidth / nativeWidth;
    var heightRatio = maxHeight != null ? maxHeight / nativeHeight : widthRatio;
    // Choose the smallest ratio to maintain the aspect ratio
    var ratio = Math.min(widthRatio, heightRatio);
    // Calculate the new dimensions
    var width = nativeWidth * ratio;
    var height = nativeHeight * ratio;
    return { width: width, height: height };
}
exports.calculateDimensionsWithConstraints = calculateDimensionsWithConstraints;
